import { render, staticRenderFns } from "./UbSelectOption.vue?vue&type=template&id=55c02beb&"
import script from "./UbSelectOption.vue?vue&type=script&lang=js&"
export * from "./UbSelectOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports